import {useParams} from 'react-router-dom'
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns'
import generatePicker from 'antd/es/date-picker/generatePicker'
import {Input} from 'antd'

import styles from './AMLGreenIDCheck.module.scss'
import greenIdImg from 'assets/images/green-id.png'
import greenId2xImg from 'assets/images/green-id@2x.png'
import {Button, Form, FormItem, Text, Box} from 'common/components'
import {formatDate} from 'common/helpers'
import {FIELD_RULES} from 'common/constants'
import {Auth, useCheckAMLGreenID} from '..'

export default function AMLGreenIDCheck() {
  const {token} = useParams()
  const {
    mutate: checkAMLGreenID,
    isMutating,
    isSuccess,
  } = useCheckAMLGreenID(token)

  const handleFinish = (values: any) => {
    const newValues = {
      dob: formatDate(values.dob, 'server'),
      address: {
        city: values.city,
        postcode: values.postcode,
      },
      lastName: values.lastName,
      givenNames: values.givenNames
        .split(',')
        .map((name: string) => name.trim()),
      middleNames: values.middleNames
        ? values.middleNames.split(',').map((name: string) => name.trim())
        : [],
    }
    checkAMLGreenID(newValues)
  }

  return (
    <Auth title={isSuccess ? undefined : 'AML Check'}>
      {isSuccess ? (
        <Box align="center">
          <Text size="4xl" mb={24}>
            Thank you!
          </Text>
          <Text maxInterval>
            Green ID has sent you an SMS message to continue the AML check.
          </Text>
        </Box>
      ) : (
        <Form className={styles.form} onFinish={handleFinish}>
          <Text size="lg" mb={32}>
            You have been beneficiated to AML check. Your identity verification
            will go inside the Green ID service. To start checking with them,
            you need to provide your personal details. After that, we will send
            you a link to your phone number and email, which you can follow for
            Green ID check.
          </Text>
          <img
            className={styles.image}
            src={greenIdImg}
            srcSet={`${greenId2xImg} 2x`}
            alt="Green ID"
          />
          <FormItem name="givenNames" label="Given name" rules={FIELD_RULES}>
            <Input />
          </FormItem>
          <FormItem name="lastName" label="Surname" rules={FIELD_RULES}>
            <Input />
          </FormItem>
          <FormItem name="middleNames" label="Middle names">
            <Input />
          </FormItem>
          <FormItem name="dob" label="Date of birth" rules={FIELD_RULES}>
            <DatePicker format="DD/MM/y" />
          </FormItem>
          <FormItem name="city" label="City" rules={FIELD_RULES}>
            <Input />
          </FormItem>
          <FormItem name="postcode" label="Postcode" rules={FIELD_RULES}>
            <Input />
          </FormItem>
          <Box mt={40}>
            <Button block htmlType="submit" loading={isMutating}>
              Send sms with Green ID link
            </Button>
          </Box>
        </Form>
      )}
    </Auth>
  )
}

export const DatePicker = generatePicker<Date>(dateFnsGenerateConfig)
